import { render, staticRenderFns } from "./AddLedgerModal.vue?vue&type=template&id=c2bd0fb8&scoped=true"
import script from "./AddLedgerModal.vue?vue&type=script&lang=js"
export * from "./AddLedgerModal.vue?vue&type=script&lang=js"
import style0 from "./AddLedgerModal.vue?vue&type=style&index=0&id=c2bd0fb8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bd0fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2bd0fb8')) {
      api.createRecord('c2bd0fb8', component.options)
    } else {
      api.reload('c2bd0fb8', component.options)
    }
    module.hot.accept("./AddLedgerModal.vue?vue&type=template&id=c2bd0fb8&scoped=true", function () {
      api.rerender('c2bd0fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/TutorStandBook/components/StudentTutor/components/AddLedgerModal.vue"
export default component.exports